jQuery(function($){
  setTimeout( function() {
    $('[data-action="add-wishlist"]').removeClass( 'xsmall' );
  }, 10000 );
  $( document ).delegate( '[data-action="add-wishlist"]', 'click', function() {
    var e = $( this ).addClass( 'adding' )
    ,k = window.surl
    ,v = $.cookie( k )
    ;
    if( !v )
    {
      v = []; 
    }
    else
    {
      v = v.split( ',' ); 
    }

    v.push( e.attr( 'data-ph' ) );

	$.cookie( k, v.join(','), { path: '/' } );
    setTimeout( function() {
    	e.removeClass( 'adding' );
    }, 1000 );
    return false;
  } );
});